import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

export interface NoteNotFoundDialogData {
  pointOfSaleName: string;
  tableNumber: number;
}

@Component({
  selector: 'app-note-not-found-dialog',
  templateUrl: './note-not-found-dialog.component.html',
  styleUrls: ['./note-not-found-dialog.component.css']
})
export class NoteNotFoundDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<NoteNotFoundDialogComponent>,
    public cssService: CssService,
    @Inject(MAT_DIALOG_DATA) public data: NoteNotFoundDialogData
  ) {}

  isClosing = false;

  selectedOption: string | null = null;

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
